import { DeviceSizes } from 'beek-design-system';

const DarkTheme = {
  colors: {
    beekBlue: 'var(--beek-blue)',
    mediumBeekBlue: 'var(--medium-beek-blue)',
    skyBlue: 'var(--sky-blue)',
    snowBlue: 'var(--snow-blue)',
    snowBlueSolid: 'var(--snow-blue-solid)',
    gray100: 'var(--gray-100)',
    gray70: 'var(--gray-70)',
    gray50: 'var(--gray-50)',
    gray35: 'var(--gray-35)',
    gray15: 'var(--gray-15)',
    white: 'var(--white)',
  },
  font: {
    primary: 'var(--primary-font)',
  },
  devices: {
    ...DeviceSizes,
  },
};

export default DarkTheme;
